<template>
  <div class="">
    <el-dialog
      :title="$t('consume.unSuggest1')"
      :visible.sync="dialogFormVisible"
      :before-close="handleClose"
      :width="$isMobile ? '90%' : '500px'"
    >
      <div class="content">
        <div>{{ $t("consume.unSuggest2") }}</div>
        <div>{{ $t("consume.unSuggest3") }}</div>
        <div>{{ $t("consume.unSuggest4") }}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      dialogFormVisible: false,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    handleClose() {
      this.dialogFormVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
/deep/.el-dialog {
  border-radius: 32px !important;
}
/deep/.el-dialog__wrapper {
  text-align: center;
  white-space: nowrap;
  overflow: auto;
  &:after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    height: 100%;
  }
  .el-dialog {
    margin: 30px auto !important;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    white-space: normal;
  }
}
.content {
  text-align: left;
  font-size: 18px;
  line-height: 30px;
  color: black;
  overflow-wrap: break-word; /* 在必要时换行 */
  word-break: normal; /* 正常换行，不会拆分单词 */
  white-space: normal; /* 允许换行 */
}

.content ul {
  margin: 10px 0;

  width: 90%;
}
.weight {
  font-weight: 700;
}
@media screen and (max-width: 1000px) {
  /deep/.el-dialog {
    width: 90%;
  }
  .content {
    font-size: 15px;
    line-height: 25px;
    overflow-y: auto;
  }
  .content ul {
    width: 80%;
  }
}
</style>
